<template>
    <div>
        <!-- Tabs Start -->
        <div class="" style="">
            <ul class="nav nav-tabs" style="display: flex; justify-content: space-evenly;">
            <li class="nav-item" v-for="(tabName, index) in tabs">
                <a
                class="nav-link ubuntu--font pb-4"
                :class="{
                    'active' : tab == index,
                    'clickAble' : tab != index
                }"
                @click="tab = index"
                >{{ tabName }}</a>
            </li>
            </ul>
        </div>
        <!-- Tabs End -->

        <div class="dealerHighlightContent innerBox">
            <!-- <div class="col-12" style="padding: 1.7rem"> -->
            <div class="col-12 p-0">

                <stock-overview
                    v-if="tab == 0"
                    :filter="filter.stockOverview"
                    :data="data.stockOverview"
                ></stock-overview>

                <aging-stock
                    v-if="tab == 1"
                    :filter="filter.agingStock"
                    :data="data.agingStock"
                ></aging-stock>

                <sales
                    v-if="tab == 2"
                    :filter="filter.sales"
                    :data="data.sales"
                ></sales>

                <territory-management
                    v-if="tab == 3"
                ></territory-management>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'

    import stockOverview from './tabs/StockOverview';
    import agingStock from './tabs/AgingStock';
    import sales from './tabs/Sales';

    import territoryManagement from '@/views/Dashboard/UserDealer/territoryUserDealer'

    export default {
        data () {
            //Frist day of the year
            let startDate = moment().startOf('year');

            //If now passes june already, add 6 month start from first day of year
            if (parseInt(moment().format("M")) > 6) startDate.add(6, 'month');

            //Sixth month from startDate
            let sixthMonth = moment(startDate).add(5, 'month').endOf('month');

            return {
                tab : 0,
                tabs : ['Stock Overview', 'Aging Stock', 'Sales', 'Territory Management'],

                //prevFilter acts as a record, will eventually have the same content of filter
                prevFilter : null,

                filter : {
                    stockOverview : {
                        stockOverviewStats : {
                            // period : moment().format("YYYY-MM-DD"),
                            period : moment().subtract(1,'days').format("YYYY-MM-DD"),
                            segment : null,
                            type : null,
                            color : null,
                            dealer : null
                        },
                        stockOverviewDoPending : {
                            // period : moment().format("YYYY-MM-DD"),
                            period : moment().subtract(1,'days').format("YYYY-MM-DD"),
                            segment : null,
                            type : null,
                            color : null,
                            dealer : null
                        },
                        stockOverviewDetails : {
                            // period : moment().format("YYYY-MM-DD"),
                            period : moment().subtract(1,'days').format("YYYY-MM-DD"),
                            segment : null,
                            type : null,
                            color : null,
                            by : 'type',
                            order : 'ASC',
                            dealer : null
                        }
                    },
                    agingStock : {
                        agingStock : {
                            // period : '2021-04-30',
                            period : moment().format("YYYY-MM-DD"),
                            segment : null,
                            type : null,
                            color : null,
                            dealer : null
                        },
                        agingStockDetails : {
                            // period : '2021-04-30',
                            period : moment().format("YYYY-MM-DD"),
                            segment : null,
                            type : null,
                            color : null,
                            by : 'series',
                            order : 'ASC',
                            dealer : null
                        },
                    },
                    sales : {
                        salesAnalysisMonthly : {
                            avgdaily : 0,
                            segment : null,
                            type : null,
                            start : startDate.format("YYYY-MM-DD"),
                            end : sixthMonth.format("YYYY-MM-DD"),
                            dealer : null
                        },
                        salesAnalysisWeekly : {
                            avgdaily : 0,
                            segment : null,
                            type : null,
                            start : startDate.format("YYYY-MM-DD"),
                            end : sixthMonth.format("YYYY-MM-DD"),
                            dealer : null
                        },
                        salesAnalysisDetails : {
                            avgdaily : 0,
                            segment : null,
                            type : null,
                            start : startDate.format("YYYY-MM-DD"),
                            end : sixthMonth.format("YYYY-MM-DD"),
                            dealer : null
                        }
                    }
                },
                data : {
                    stockOverview : {
                        stockOverviewStats : null,
                        stockOverviewDoPending : null,
                        stockOverviewDetails : null,
                    },
                    agingStock : {
                        agingStock : null,
                        agingStockDetails : null,
                    },
                    sales : {
                        salesAnalysisMonthly : null,
                        salesAnalysisWeekly : null,
                        salesAnalysisDetails : null,
                    }
                },


                //Each variable value is the url for the section, example:
                //          api_url.sales.salesAnalysisMonthly is for:
                //          'https://{{server}}/api/highlight-dealer/sales-analysis?monthly=1'
                //
                //
                //Format:   pageVar : {
                //              dataVar : url_of_section
                //          }
                api_url : {
                    stockOverview : {
                        stockOverviewStats : "stock-overview",
                        stockOverviewDoPending : "stock-overview/do-pending",
                        stockOverviewDetails : "stock-overview/details"
                    },
                    agingStock : {
                        agingStock : "aging-stock",
                        agingStockDetails : "aging-stock/details"
                    },
                    sales : {
                        salesAnalysisMonthly : "sales-analysis?monthly=1",
                        salesAnalysisWeekly : "sales-analysis?monthly=0",
                        salesAnalysisDetails : "sales-analysis?monthly=1",
                    }
                }
            }
        },
        components : {
            stockOverview,
            agingStock,
            sales,

            territoryManagement,
        },
        async mounted () {
            await this.resetOperations();

            this.fetchData();
        },
        watch : {
            //INDIVIDUAL FILTERS
            //Stock Overview
            'filter.stockOverview' : {
                deep : true,
                handler (val) {
                    for (var i in val) {
                        if (JSON.stringify(val[i]) !== JSON.stringify(this.prevFilter.stockOverview[i]))
                            this.fetchData('stockOverview', i);
                    }

                    this.prevFilter.stockOverview = JSON.parse(JSON.stringify(this.filter.stockOverview))
                }
            },
            //Stock Analytics
            'filter.agingStock' : {
                deep : true,
                handler (val) {
                    for (var i in val) {
                        if (JSON.stringify(val[i]) !== JSON.stringify(this.prevFilter.agingStock[i]))
                            this.fetchData('agingStock', i);
                    }

                    this.prevFilter.agingStock = JSON.parse(JSON.stringify(this.filter.agingStock))
                }
            },
            //Sales Analytics
            'filter.sales' : {
                deep : true,
                handler (val) {
                    for (var i in val) {
                        if (JSON.stringify(val[i]) !== JSON.stringify(this.prevFilter.sales[i]))
                            this.fetchData('sales', i);
                    }

                    this.prevFilter.sales = JSON.parse(JSON.stringify(this.filter.sales))
                }
            }
        },
        methods : {
            getCurrentPageVariable () {
                let keys = Object.keys(this.data);
                return keys[this.tab]
            },
            resetOperations () {
                //Set Date Ranges
                // let start = moment().startOf('month').format('YYYY-MM-DD 00:00:00')
                // let end = moment().format('YYYY-MM-DD 23:59:59')
                // let start = moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
                // let end = moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')

                // for (var i in this.filter) {
                //     for (var j in this.filter[i]) {
                //         this.filter[i][j].start = start;
                //         this.filter[i][j].end = end;
                //     }
                // }

                // Duplicate current filter to prevFilter
                this.prevFilter = JSON.parse(JSON.stringify(this.filter));
            },
            fetchData (pageVar, dataVar) {
                /*
                    var data will fill like this:
                    {
                        pageVar1 : ['dataVar1','dataVar2','dataVar3'],
                        pageVar2 : ['dataVar4','dataVar5','dataVar6']
                    }

                    api_url will be invoked when calling api
                */
                var data = {};

                //If Page is provided
                if (pageVar) {
                    //If Data Variable is provided
                    if (dataVar) {
                        //Only the specific data variable will be called
                        data[pageVar] = [dataVar]
                    } else {
                        //All data variable in the page will be called
                        data[pageVar] = Object.keys(this.api_url[pageVar])
                    }
                } else {//Initial load data will not provide any speicific pageVar as all data will be loaded
                    //Seek all object keys from api_url
                    let pageKeys = Object.keys(this.api_url)

                    //Put every single data variable key to page, to create the above commented example
                    for (var i in pageKeys) data[pageKeys[i]] = Object.keys(this.api_url[pageKeys[i]]);
                }


                //URL Acquisition complete, starting fetching data loop


                for (var i in data) {//First layer: page keys
                    for (var j in data[i]){//Second layer: data variables

                        //Saves these variables for this current loop, so it won't be replaced when api has load,
                        //as urls can be overwritten when all these APIs are called synchronously at the same time.
                        let currPage = i;
                        let currVariable = data[i][j];
                        let currUrl = this.api_url[currPage][currVariable];
                        // console.log(`currPage=${currPage}\ncurrVariable=${currVariable}\ndata of currPage=${JSON.stringify(this.data[i])}\ncurrUrl=${currUrl}`);

                        //Reset data to null to set some loading animations
                        this.data[currPage][currVariable] = null;

                        //Regex test will add '?' if there is none yet in currUrl
                        let url = `/api/highlight-dealer/${currUrl}${currUrl.match(/\?/) ? '&' : '?'}`

                        //Adds filter based on the current configurations
                        url = url + qs.stringify(this.filter[currPage][currVariable], {skipNulls:true, arrayFormat: 'comma'})

                        //Fetch the data
                        this.$http.get(url)
                        .then((resp)=>{

                            //If variable data is 'agingStock'
                            if (currVariable == 'agingStock') {
                                this.data[currPage][currVariable] = {
                                    data : resp.data.data[0],
                                    stats : resp.data.meta
                                }
                            }

                            // else if (currVariable == 'stockOverviewDetails') {
                            //     console.log(`resp.data.data : ${JSON.stringify(resp.data.data)}`);
                            //     this.data[currPage][currVariable] = resp.data.data;
                            // }
                            
                            //Default data storing of fetch result
                            else {
                                this.data[currPage][currVariable] = resp.data.data;
                            }
                        })
                        .catch((err)=>{console.log(err)})

                    }//End of second layer loop
                }//End of first layer loop
            },
        }
    }
</script>

<style scoped>
    .nav-tabs, .nav-link{
        border:1px solid transparent !important;
    }
    .nav-tabs {
        /* border-bottom: 1px solid #dee2e6 !important; */
        border-bottom: 0 !important;
    }
    .nav-link{
        border:1px solid !important;
        border-radius: 16px 16px 0 0;
        border-color: #FFB182 !important;
        /* border-bottom: 1px solid #F36F21 !important; */
        background-image: none;
        background-color: #fff;
        color: #FFB182 !important;
        font-size: 0.9rem;

        transition: 0.3s border-color ease;
        transition: 0.3s color ease;
    }
    .nav-link:before {
        content: "";
        box-shadow: 0 3px 6px #00000029;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
    }
    .nav-link.active{
        /* background-color: #fff;
        border-color:#F36F21 #F36F21 #fff !important;
        color: #F36F21 !important; */
        /* background-color:#F5F5F5; */
        /* border-width: 2px !important; */
        background-color: #F36F21;
        color: white !important;

        font-weight: bold !important;
    }

    .nav-item {
        width:25%;
        text-align: center;
        border-bottom: 0;
    }
    .clickAble:hover{
        cursor:pointer;
    }

    .dealerHighlightContent {
        z-index: 1;
        border-radius: 15px;
        border-color:#F36F21;
        transform: translateY(-15px);
    }
</style>